var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.6 3.5-.4.4V2.8c0-.5-.4-.8-.8-.8s-.8.3-.8.8v3c0 .2.1.4.2.6.2.1.4.2.6.2h3.1c.2 0 .4-.1.6-.2.1-.1.1-.4.2-.6 0-.4-.4-.8-.8-.8H4.3l.4-.4c2.1-2.1 5.6-2.1 7.6 0s2.1 5.6 0 7.6c-2.1 2.1-5.6 2.1-7.6 0-.9-.9-1.5-2.2-1.6-3.5 0-.4-.4-.8-.8-.7-.4 0-.8.4-.7.8.1 1.7.8 3.3 2 4.5 2.7 2.7 7.2 2.8 9.9 0s2.8-7.2 0-9.9C10.7.8 6.3.8 3.6 3.5"
  })));
};
export default SvgReset;